module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_14.4b7e1f27.jpg";